import { Outlet } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Logo from "@/components/site/Logo";
import Seo from "@/components/site/Seo";

export const ClerkLayout = () => (
  <ClerkAuthProvider><Outlet /></ClerkAuthProvider>
);

const Frame = ({ children }) => (
  <div className="min-h-screen bg-[#F1F4F6] grid-bg flex flex-col items-center justify-center gap-8 px-4 py-12" data-testid="admin-auth-page">
    <Seo title="Admin sign in" noindex />
    <Logo />
    <div className="flex items-center justify-center">{children}</div>
    <p className="text-xs text-[#64728A] text-center max-w-sm">Restricted area for authorized SaaSPivora administrators.</p>
  </div>
);

export const SignInPage = () => (
  <Frame><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/admin" /></Frame>
);
export const SignUpPage = () => (
  <Frame><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/admin" /></Frame>
);
